import { gql } from "@apollo/client";

export const UPDATE_USER = gql`
  mutation UpdateUser($id: Int!, $password: String, $username: String, $email: String, $phone: String) {
    updateUser(updateUserInput: {
      id: $id
      password: $password
      username: $username
      email: $email
      phone: $phone
    }) {
      id
      username
      email
      phone
      Balance {
        id
        amount
        credit
        onHold
      }
      credit
      isActive
      parentId
      comment
      lastLogin
      loginIp
      avatarUrl
      language
      timezone
      createdAt
      updatedAt
    }
  }
`;